import React from 'react';
import '../template-file-css/document-file-template.css';


export const RFS_ChildConcurrentFunctionalCriteria = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RFS_ChildConcurrentFunctionalCriteria' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'><center><h3>Functional Impairments</h3></center>
                    Within the past three months, the individual's emotional disturbance has resulted in:*</p>

                <p className='w-750'><span className='eleHeader'>1.  a. A clear, current threat to the youth's ability to be maintained in their customary setting?*
                    Please provide explanation, if Yes or No</span>
                    <input type='radio' id='rbClearCurrentThreatToTheYouthAbility_Yes' name='rbClearCurrentThreatToTheYouthAbility' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClearCurrentThreatToTheYouthAbility_No' name='rbClearCurrentThreatToTheYouthAbility' className='add-only' value='No' /> No<br />
                    <textarea id='txtClearCurrentThreatToTheYouthAbility' name='txtClearCurrentThreatToTheYouthAbility' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>b. An emerging risk to the safety of the youth or others?*</span>
                    <input type='radio' id='rbAnEmergingRiskToSafetyOfTheYouthOrOther_Yes' name='rbAnEmergingRiskToSafetyOfTheYouthOrOther' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAnEmergingRiskToSafetyOfTheYouthOrOther_No' name='rbAnEmergingRiskToSafetyOfTheYouthOrOther' className='add-only' value='No' /> No <br />
                    If yes, provide evidence of an emerging risk to the safety of the youth or others:<br />
                    <textarea id='txtIfYesProvideEvidenceOfAnEmergingRisk' name='txtIfYesProvideEvidenceOfAnEmergingRisk' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>c. Significant psychological or social impairments causing serious problems with peer
                    relationships and/or family members?*</span>
                    <input type='radio' id='rbSignificantPsychologicalOrSocialImpairments_Yes' name='rbSignificantPsychologicalOrSocialImpairments' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSignificantPsychologicalOrSocialImpairments_No' name='rbSignificantPsychologicalOrSocialImpairments' className='add-only' value='No' /> No <br />
                    If yes, provide evidence of significant psychological or social impairments causing serious
                    problems with peer relationships and/or family members:<br />
                    <textarea id='txtIfYesProvideEvidenceOfSignificantPsychologicalSocial' name='txtIfYesProvideEvidenceOfSignificantPsychologicalSocial' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>2. What evidence exists to show that the current intensity of outpatient treatment for this individual is
                    insufficient to reduce the youth's symptoms and functional behavioral impairments resulting from mental
                    illness?*</span><br />
                    <textarea id='txtWhatEvidenceExistsToShowThatTheCurrentIntensityOfOutpatient' name='txtWhatEvidenceExistsToShowThatTheCurrentIntensityOfOutpatient' className='add-only'></textarea></p>


                <p className='w-750'><span className='eleHeader'>3. Has the youth made progress toward age appropriate development, more independent
                    functioning and independent living skills?*</span>
                    <input type='radio' id='rbHasTheYouthMadeProgressTowardAgeAppropriate_Yes' name='rbHasTheYouthMadeProgressTowardAgeAppropriate' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHasTheYouthMadeProgressTowardAgeAppropriate_No' name='rbHasTheYouthMadeProgressTowardAgeAppropriate' className='add-only' value='No' /> No <br />
                    If so, describe the improvement:<br />
                    <textarea id='txtIfSoDescribeTheImprovement' name='txtIfSoDescribeTheImprovement' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>4. Has a crisis plan been completed with family and/or guardian?*</span>
                    <input type='radio' id='rbHasCrisisPlanBeenCompletedWith_Yes' name='rbHasCrisisPlanBeenCompletedWith' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHasCrisisPlanBeenCompletedWith_No' name='rbHasCrisisPlanBeenCompletedWith' className='add-only' value='No' /> No 
                </p>


                




























            </div >
        </form >

    )
}











